var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackcompanyScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 634.44048,
    y1: 630.88619,
    x2: 711.05694,
    y2: 713.47983,
    gradientTransform: "translate(730 730) rotate(-90) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5aaaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#4ccbe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3dedcf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.38909,21.82253c-2.12302,18.78499-2.12302,37.56996,0,56.35494.62055,5.49081,4.94264,9.8129,10.43345,10.43345,18.78497,2.12301,37.56995,2.12301,56.35493,0,5.49081-.62055,9.8129-4.94265,10.43345-10.43346,2.12301-18.78498,2.12301-37.56995,0-56.35494-.62055-5.49081-4.94264-9.8129-10.43345-10.43346-18.78497-2.12301-37.56995-2.12301-56.35492,0-5.49081.62055-9.8129,4.94265-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.21344,68.83221c2.40686,0,4.36517-1.95868,4.36517-4.36597v-7.03125c0-.80353-.65149-1.45575-1.45551-1.45575-.80334,0-1.45483.65222-1.45483,1.45575v7.03125c0,.80219-.65277,1.45514-1.45483,1.45514h-10.01367c-.28613,0-.56573.08447-.80408.24292l-4.21918,2.79822v-18.08075c0-.80219.65216-1.45508,1.45483-1.45508h2.42523c.80402,0,1.45551-.65161,1.45551-1.45581,0-.80347-.65149-1.45508-1.45551-1.45508h-2.42523c-2.4068,0-4.36584,1.95868-4.36584,4.36597v20.79254c0,.53638.29529,1.02881.7674,1.2829.21539.11523.45178.17291.68811.17291.28088,0,.56177-.08191.80469-.24231l6.11273-4.0556h9.57501Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.26038,56.29681c.24292.16113.52319.24298.80408.24298.23633,0,.47205-.05762.68878-.17352.47205-.25348.76672-.74591.76672-1.28223v-23.84814c0-2.40729-1.95837-4.36603-4.36591-4.36603h-16.08313c-2.40619,0-4.36523,1.95874-4.36523,4.36603v16.08539c0,2.4079,1.95905,4.36664,4.36523,4.36664h11.24133l6.94812,4.60889ZM52.6167,47.32129v-16.08539c0-.80225.65277-1.45514,1.45422-1.45514h16.08313c.80273,0,1.45551.65289,1.45551,1.45514v21.13635l-5.05463-3.35223c-.23834-.15851-.51788-.24298-.80402-.24298h-11.67999c-.80145,0-1.45422-.65289-1.45422-1.45575Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.24744,60.51416c.21606.11591.45178.17285.68817.17285.28088,0,.56177-.08118.80469-.24225l5.06903-3.36273c.59973-.39819.81909-1.17487.51526-1.82776-.37646-.80676-1.38214-1.09033-2.12396-.5979l-2.80951,1.86377v-18.08075c0-.80353.65082-1.45514,1.45416-1.45514h14.21259c.85248,0,1.53473-.73474,1.44702-1.60638-.07532-.75702-.76935-1.30444-1.53015-1.30444h-14.12946c-2.4101,0-4.36517,1.95471-4.36517,4.36597v20.79254c0,.53571.29529,1.02881.76733,1.28223Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackcompanyScraper);
export default __webpack_public_path__ + "static/media/feedbackcompany-scraper.3e5093a55ed132097abbb4402b7aeebe.svg";
export { ForwardRef as ReactComponent };